module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "support"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('svg', {
    staticClass: "svg100",
    attrs: {
      "ratio": "0.33",
      "fill": "#ffffff",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1920 640"
    }
  }, [_c('title', [_vm._v("supportblock_white")]), _c('polygon', {
    attrs: {
      "points": "0 0 1920 640 0 640 0 0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "txtcontent strip"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btnblock"
  }, [_c('a', {
    staticClass: "btn wow5",
    attrs: {
      "href": "donate.pdf",
      "onclick": "gaclick('btn_donatedownload')",
      "download": ""
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 40.42 36.37"
    }
  }, [_c('title', [_vm._v("download")]), _c('path', {
    attrs: {
      "d": "M39.92,28.47h-2a.5.5,0,0,0-.5.5V33.4H3V29a.5.5,0,0,0-.5-.5H.5A.5.5,0,0,0,0,29v5.91a1.49,1.49,0,0,0,1.49,1.49H38.93a1.49,1.49,0,0,0,1.49-1.49V29A.5.5,0,0,0,39.92,28.47Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.06,30.41a1.57,1.57,0,0,0,2.55-.86,1.2,1.2,0,0,0,.25-.52c3.06-3.31,6.51-6.17,9.65-9.4,1.34-1.37-.77-3.48-2.1-2.1-2.48,2.55-5.16,4.88-7.69,7.37-.29-7.81,0-15.65-.12-23.46a1.49,1.49,0,0,0-3,0c.12,8.2-.19,16.42.17,24.62-3.3-3.3-6.29-6.9-9.79-10-1.43-1.27-3.54.83-2.1,2.1C12.22,22,15.74,26.57,20.06,30.41Z"
    }
  })])]), _c('span', [_vm._v("下載捐款單")])]), _vm._v(" "), _c('a', {
    staticClass: "btn wow6",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.childOpen()
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 39.47 28.79"
    }
  }, [_c('title', [_vm._v("video")]), _c('g', {
    attrs: {
      "data-name": "video"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.28,3.63a1.91,1.91,0,0,0,2.35-1.47.62.62,0,0,0,0-.34A1.65,1.65,0,0,0,37.38.94a16,16,0,0,0-2.8-.41c-2.77-.15-5.92-.31-9-.38C18.37,0,10.91-.16,3.44.34.86.51.06,1,0,3.78,0,10.67,0,17.59,0,22.84a20.44,20.44,0,0,0,.27,2.78c.05.36.1.71.15,1.07a1.76,1.76,0,0,0,1.75,1.67c.44,0,.88.07,1.33.12.59.06,1.18.12,1.78.14q5.85.18,11.67.18c5.3,0,10.56-.11,15.74-.33a33.42,33.42,0,0,0,3.85-.4c1.56-.25,1.89-.76,2.09-2.18a93.72,93.72,0,0,0,.74-15.81A12,12,0,0,0,39,7.39a1.62,1.62,0,0,0-1.64-1,1.25,1.25,0,0,0-.92.63,1.49,1.49,0,0,0,0,1.32,1.52,1.52,0,0,1,.14.58v2.31c0,2.59,0,5.26-.07,7.88,0,1.2-.16,2.43-.28,3.62-.08.84-.17,1.68-.23,2.52,0,.08,0,.13,0,.14l-.2,0-1.61.13c-1,.09-2,.18-3.06.19-6.84.07-14.23.12-23.24.16-1,0-2.07,0-3.08-.09l-1.69-.07H3a7.6,7.6,0,0,0-.07-1c0-.23-.06-.47-.06-.7l-.07-3.27c-.09-4.16-.19-8.45-.23-12.68,0-1.23.07-2.46.15-3.76,0-.4.05-.8.08-1.2A283.66,283.66,0,0,1,35,3.31Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M16,21.77A2.93,2.93,0,0,1,13,18.84V8.8A2.93,2.93,0,0,1,17.6,6.37l7.52,5a2.93,2.93,0,0,1,0,4.88l-7.52,5A2.92,2.92,0,0,1,16,21.77ZM16,8.28a.53.53,0,0,0-.25.06.5.5,0,0,0-.28.46v10a.51.51,0,0,0,.28.46.51.51,0,0,0,.54,0l7.52-5a.53.53,0,0,0,0-.88l-7.51-5A.54.54,0,0,0,16,8.28Z"
    }
  })])])]), _c('span', [_vm._v("關於200個小王子  ")])])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "wow3"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/support1.svg"),
      "alt": "支持"
    }
  }), _c('br', {
    staticClass: "desktop_only"
  }), _c('img', {
    staticClass: "secondtxt",
    attrs: {
      "src": require("../../asset/svg/title/support2.svg"),
      "alt": "多寶創作人"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "wow4"
  }, [_vm._v(" 許多創作型泛自閉症青年，"), _c('br', {
    staticClass: "desktop_only"
  }), _vm._v("都面對需要一份可安身立命的工作的困難"), _c('br'), _vm._v("藝術創作是他們困難的生命裡最擅長的美好"), _c('br'), _vm._v("一起幫助差異的生命，"), _c('br', {
    staticClass: "desktop_only"
  }), _vm._v("散發他們獨有的神采，美麗我們的世界"), _c('br'), _c('b', [_vm._v("認同多寶，幫助與支持")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supportpic wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/support_pic.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c67736c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Support.vue
// module id = 255
// module chunks = 0